module.exports = __webpack_public_path__ + "static/media/V1.72424132.png";